import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';

export class GaTrackingPdpFoodCategoryLinkEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.payload.action,
      label: this.payload.label,
      gtmCustom: {
        action: this.payload.action,
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
